import { useState } from 'react';

import { FormField, Label, Select } from '@zillow/constellation-10';

import { AgentLicenseType as AgentLicenseTypeEnum } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type { ChangeEvent } from 'react';
interface StringMap {
  [key: string]: string;
}

const BROKER_LICENSE_MAP: StringMap = {
  [AgentLicenseTypeEnum.REAL_ESTATE_SALES_PERSON]: 'Real Estate Sales Person',
  [AgentLicenseTypeEnum.REAL_ESTATE_BROKER]: 'Real Estate Broker',
  [AgentLicenseTypeEnum.ASSOCIATE_REAL_ESTATE_BROKER]: 'Associate Real Estate Broker',
};

type handleChangeArgs = {
  name: string;
  value: string;
};

type AgentLicenseTypeProps = {
  agentLicenseType?: string;
  name?: string;
  onChange: (args: handleChangeArgs) => void;
};

const AgentLicenseType = ({ agentLicenseType, name = 'agentLicenseType', onChange }: AgentLicenseTypeProps) => {
  const [value, setValue] = useState(agentLicenseType);

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    const {
      target: { name, value },
    } = event;

    setValue(value);
    onChange({ name, value });
  };

  return (
    <div data-testid="AgentLicenseType">
      <FormField
        label={<Label>License type</Label>}
        control={
          <Select name={name} value={value} size="md" onChange={handleChange} css={{ whiteSpace: 'pre' }}>
            {/* @ts-expect-error - null value is intentional for empty option */}
            <option value={null} key="no-value" aria-label="no-value" />

            {Object.keys(BROKER_LICENSE_MAP).map((key: keyof typeof BROKER_LICENSE_MAP) => {
              return (
                <option key={key} value={key} aria-label={BROKER_LICENSE_MAP[key]}>
                  {BROKER_LICENSE_MAP[key]}
                </option>
              );
            })}
          </Select>
        }
      />
    </div>
  );
};

export { BROKER_LICENSE_MAP };

export default AgentLicenseType;
